export default "__VITE_ASSET__CpP7DMib__"